import React from 'react';
import Accordion from "../../components/accordion";
import DataLoader from "../../components/loader/dataLoader";
import useFAQs from "../../hooks/public/useFAQs";
import "../../assets/css/pages/faq/style.scss";

const Index = () => {
    const {data,isLoading} = useFAQs();

    return (
        <section className='faq-section'>
            <div className='custom-container'>
                <div className='content-section'>
                    <h1 className='page-title'>FAQ</h1>
                    <div className='content-body'>
                        {isLoading && <DataLoader/>}
                        {
                            data && data.map(item =>
                                <Accordion
                                    key={item.id}
                                    title={item.questionEn}
                                    content={item.answerEn}
                                />)
                        }
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Index;
